<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="所属部门">
              <j-select-depart v-model="queryParam.sysOrgCode" customReturnField="orgCode"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="8">
            <a-form-item label="协议编码" >
              <a-input v-model.trim="queryParam.protocolCode" placeholder="请输入协议编码"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="8">
            <a-form-item label="针对业务">
              <a-input v-model.trim="queryParam.projectBranch" placeholder="请输入针对业务"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :md="8" :sm="12">
              <a-form-item label="公章名称" >
                <j-dict-select-tag type="list" v-model="queryParam.officialSealName"
                                   dictCode="name_of_official_seal"
                                   placeholder="请选择公章名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="12">
              <a-form-item label="对方公司">
                <j-search-select-tag type="list" v-model="queryParam.oppositeCompanyName" dict="biz_insurance_company,name,code" placeholder="请选择对方公司"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="8">
              <a-form-item label="协议种类">
                <j-dict-select-tag type="list" v-model="queryParam.protocolType" dictCode="agreement_type" placeholder="请选择"/>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="8">
              <a-form-item label="协议起期">
                <j-date placeholder="请选择协议起期" v-model="queryParam.startDateOfAgreement"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="8">
              <a-form-item label="协议止期">
                <j-date placeholder="请选择协议止期" v-model="queryParam.endDateOfAgreement" @change="handleEndDateChange"/>
                <a-checkbox @change="handleEndLessChange" :checked="isEndLess">长期</a-checkbox>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="3" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
              {{ toggleSearchStatus ? '收起' : '展开' }}
              <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
            </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'agreementInfo:add'">新增</a-button>
      <!--<j-super-query :fieldList="fieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>-->
      <a-button type="primary" icon="download" @click="handleExportXls('协议管理表')" v-has="'agreementInfo:export'">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel" v-has="'agreementInfo:import'">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <!--<a-dropdown v-if="selectedRowKeys.length > 0" v-has="'agreementInfo:del'"> &lt;!&ndash;批量操作只有删除一种操作，和删除权限绑定&ndash;&gt;-->
        <!--<a-menu slot="overlay">-->
          <!--<a-menu-item key="1" @click="batchDel" ><a-icon type="delete"/>删除</a-menu-item>-->
        <!--</a-menu>-->
        <!--<a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>-->
      <!--</a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(downUrl+text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)"  v-has="'agreementInfo:edit'">编辑</a>
          <a-divider type="vertical"  v-has="'agreementInfo:edit'" />

          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>

              <a-menu-item v-if="record.status == '0'" v-has="'agreementInfo:confirm'">
                <a @click="confirmAgreement(record)">确认</a>
              </a-menu-item>
              <a-menu-item v-if="record.status == '1' && record.endDateOfAgreement != '长期'" v-has="'agreementInfo:delay'">
                <a @click="updateEndDate(record)">延期</a>
              </a-menu-item>

              <a-menu-item v-if="record.status == '0'" v-has="'agreementInfo:del'">
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)" >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <biz-agreementinfo-modal ref="modalForm" @ok="modalFormOk"></biz-agreementinfo-modal>
    <a-modal v-model="modalVisible" title="选择协议截止日期" @ok="handleNewEndDateOk">
      <lable>协议止期：</lable>
      <j-date placeholder="请选择协议止期" v-model="newEndDate" :trigger-change="true" />
    </a-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BizAgreementinfoModal from './modules/BizAgreementinfoModal'
  import JDate from '@/components/jeecg/JDate'
  import { filterObj } from '@/utils/util'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import {postAction} from '@/api/manage'

  export default {
    name: 'BizAgreementinfoList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      BizAgreementinfoModal,
      JSelectDepart,
      JDate,
      JSearchSelectTag,
      //JSuperQuery,
    },
    data () {
      return {
        description: '协议管理表管理页面',
        newEndDate: '',
        modalVisible: false,
        updateId: '',
        isEndLess: false,
        downUrl:window._CONFIG['downloadUrl'],
        //fieldList: superQueryFieldList,
        //superQueryFlag: false,
        //superQueryParams: '',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'状态',
            align:"center",
            dataIndex: 'status_dictText',
          },
          {
            title:'所属部门',
            align:"left",
            dataIndex: 'sysOrgCode_dictText',
            sorter: true
          },
          {
            title:'协议编码',
            align:"left",
            dataIndex: 'protocolCode',
            sorter: true
          },
          {
            title:'针对业务',
            align:"left",
            dataIndex: 'projectBranch'
          },
          {
            title:'公章名称',
            align:"left",
            dataIndex: 'officialSealName_dictText'
          },
          {
            title:'协议种类',
            align:"left",
            dataIndex: 'protocolType_dictText'
          },
          {
            title:'对方公司名称',
            align:"left",
            dataIndex: 'oppositeCompanyName_dictText'
          },
          {
            title:'文本提供方',
            align:"left",
            dataIndex: 'agreementProvider'
          },
          {
            title:'协议类型',
            align:"left",
            dataIndex: 'forBusiness_dictText'
          },
          {
            title:'险种',
            align:"left",
            dataIndex: 'typeOfInsurance'
          },
          {
            title:'佣金比例',
            align:"left",
            dataIndex: 'commissionRate'
          },
          {
            title:'协议名称',
            align:"left",
            dataIndex: 'agreementName'
          },
          {
            title:'一式份数',
            align:"center",
            dataIndex: 'numberOfCopies'
          },
          {
            title:'自留份数',
            align:"center",
            dataIndex: 'selfRetentionNumber'
          },
          {
            title:'协议起期',
            align:"left",
            dataIndex: 'startDateOfAgreement',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'协议止期',
            align:"left",
            dataIndex: 'endDateOfAgreement',
            sorter: true,
            customRender:function (text) {
              if(text =='2099-12-31 23:59:59'){
                return '长期'
              }
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'申请日期',
            align:"left",
            dataIndex: 'dateOfApplication',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'申请人',
            align:"left",
            dataIndex: 'applicant_dictText'
          },
          {
            title:'保险公司联系人',
            align:"left",
            dataIndex: 'insuranceCompanyContact'
          },
          {
            title:'联系人电话',
            align:"left",
            dataIndex: 'contactNumber'
          },
          // 隐藏，单独弹窗查看 或者在详情查看
          // {
          //   title:'备注',
          //   align:"left",
          //   width: 60,
          //   dataIndex: 'remarks',
          //   scopedSlots: {customRender: 'htmlSlot'}
          // },
          {
            title:'协议附件',
            align:"left",
            dataIndex: 'agreementPicture',
            scopedSlots: {customRender: 'fileSlot'}
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/biz/bizAgreementinfo/list",
          delete: "/biz/bizAgreementinfo/delete",
          deleteBatch: "/biz/bizAgreementinfo/deleteBatch",
          exportXlsUrl: "/biz/bizAgreementinfo/exportXls",
          importExcelUrl: "biz/bizAgreementinfo/importExcel",
          // 协议延期
          changeStatus: "/biz/bizAgreementinfo/changeStatus",
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      // handleSuperQuery(arg, matchType) {
      //   if (!arg) {
      //     this.superQueryParams = ''
      //     this.superQueryFlag = false
      //   } else {
      //     this.superQueryFlag = true
      //     this.superQueryParams = JSON.stringify(arg)
      //     this.superQueryMatchType = matchType
      //   }
      //   this.loadData()
      // },
      getQueryParams() {
        // let sqp = {}
        // if (this.superQueryParams) {
        //   sqp['superQueryParams'] = encodeURI(this.superQueryParams)
        //   sqp['superQueryMatchType'] = this.superQueryMatchType
        // }
        // var param = Object.assign(sqp, this.queryParam, this.isorter)

        var param = Object.assign({}, this.queryParam, this.isorter ,this.filters)
        if(param.protocolCode){
          param.protocolCode = `*${param.protocolCode}*` // 模糊匹配字段
        }
        if(param.projectBranch){
          param.projectBranch = `*${param.projectBranch}*` // 模糊匹配字段
        }
        if(param.startDateOfAgreement){
          param.startDateOfAgreement = param.startDateOfAgreement + ' 00:00:00' //起始日期添加0
        }
        if(param.endDateOfAgreement){
          param.endDateOfAgreement = param.endDateOfAgreement + ' 23:59:59' //起始日期添加0
        } else if(this.isEndLess){
          param.endDateOfAgreement = '2099-12-31 23:59:59'
        }

        param.field = this.getQueryField()
        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param)
      },
      handleRuleChange(item, newValue) {
        let oldValue = item.rule
        this.$set(item, 'rule', newValue)
        // 上一个规则是否是 in，且type是字典或下拉
        if (oldValue === 'in') {
          if (item.dictCode || item.options instanceof Array) {
            let value = item.val
            if (typeof item.val === 'string') {
              value = item.val.split(',')[0]
            } else if (Array.isArray(item.val)) {
              value = item.val[0]
            }
            this.$set(item, 'val', value)
          }
        }
      },
      // 确认
      confirmAgreement(record){
        let param = {id: record.id, status: 1}
        postAction(this.url.changeStatus, param).then((res) =>{
          if(res.success){
            this.$message.success("确认成功")
            this.loadData()
          }else{
            this.$message.error("确认失败：" + res.message)
          }
        })
      },
      // 延期
      updateEndDate(record){
        this.modalVisible = true;
        this.updateId = record.id;
      },

      handleNewEndDateOk(){
        this.modalVisible = false;
        if(this.newEndDate.indexOf('23:59:59') < 0){
          this.newEndDate = this.newEndDate +' 23:59:59'
        }
        let param = {id: this.updateId, status: 2, endDate: this.newEndDate}
        postAction(this.url.changeStatus, param).then((res) =>{
          if(res.success){
            this.$message.success("延期成功")
            this.loadData();
          }else{
            this.$message.error("延期失败：" + res.message)
          }
        })
      },

      handleEndDateChange(value){
        // if(value != null && value.trim() != ''){
        // }
        this.isEndLess = false
        this.queryParam.endDateOfAgreement = value;
      },
      // 长期按钮
      handleEndLessChange(event){
        if(event && event.target.checked){
          this.isEndLess = true;
          this.queryParam.endDateOfAgreement = null;
        } else{
          this.isEndLess = false
        }
      },

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>